class ReaperSizeGuide extends HTMLElement {
 connectedCallback() {
  if (this.controller) return;
  this.controller = new AbortController();
  const {signal} = this.controller;
  const dialog = this.querySelector('dialog');
  this.trigger = this.querySelector('.rsg-trigger');
  const scope = this.closest('.shopify-section') || this.parentElement;
  const place = () => {
   const pickers = scope.querySelectorAll('variant-picker');
   for (const picker of pickers) {
    if (picker.dataset.productId !== this.dataset.productId) continue;
    for (const field of picker.querySelectorAll('fieldset')) {
     const name = field.querySelector('input')?.dataset.optionName?.toLowerCase();
     if (!['talla', 'tallas', 'size'].includes(name)) continue;
     const legend = field.querySelector('legend');
     if (legend && this.trigger.parentElement !== legend) {
      legend.classList.add('rsg-size-row');
      legend.append(this.trigger);
     }
     return;
    }
   }
  };
  place();
  this.observer = new MutationObserver(place);
  this.observer.observe(scope, {childList:true, subtree:true});
  this.trigger.addEventListener('click', () => {
   if (dialog.open) return;
   this.oldOverflow = document.body.style.overflow;
   dialog.showModal();
   document.body.style.overflow = 'hidden';
  }, {signal});
  this.querySelector('.rsg-close').addEventListener('click', () => dialog.close(), {signal});
  dialog.addEventListener('click', event => {
   if (event.target !== dialog) return;
   const r = dialog.getBoundingClientRect();
   if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) dialog.close();
  }, {signal});
  dialog.addEventListener('close', () => {
   document.body.style.overflow = this.oldOverflow || '';
   this.trigger.focus();
  }, {signal});
 }
 disconnectedCallback() {
  this.observer?.disconnect();
  this.controller?.abort();
  this.controller = null;
  if (this.querySelector('dialog')?.open) document.body.style.overflow = this.oldOverflow || '';
  if (this.trigger && !this.contains(this.trigger)) this.prepend(this.trigger);
 }
}
if (!customElements.get('reaper-size-guide')) customElements.define('reaper-size-guide', ReaperSizeGuide);
